<template>
    <div id="app" class="app">
        <navbar></navbar>
        <router-view></router-view>
        <bottom></bottom>
    </div>
</template>

<script>
import navbar from './components/navbar';
import bottom from './components/bottom';
export default {
    created(){
    
    },
    mounted(){
        var locale = window.localStorage.getItem('locale');
        if(locale != null){
            this.$i18n.locale = locale;
        }
    },
    components: {
       navbar,
       bottom
    },
};
</script>

<style>
body{
    margin:0px;
    padding:0px;
}

a{
    color:#666;
}

a:hover{
    color:#526193 !important;
    text-decoration:none;
}

.dropdown-item.active, .dropdown-item:active{
    background:#526193 !important;
    color:white !important;
}

.form-control{
    box-shadow:0px 0px 8px #e5e5e5 !important;
}

.form-control:focus{
    box-shadow:0px 0px 15px #e5e5e5 !important;
    border:1px solid #ced4da !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?c50b7900